import { ForceSignInDto } from 'src/common/interfaces/dtos/IForceSignIn';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { EmeraldDialogTypes } from '../../common/enumerations/emerald-dialog-types';
import { LocalStorage } from '../../common/helpers/local-storage';
import { ILoginUser } from '../../common/interfaces/dtos/ILoginUser';
import { store } from '../../common/redux/configure-store';
import { LoginActions } from '../../common/redux/reducers/login-reducer';
import { disablePayments, enablePayments } from 'src/devices/payment/pinpad-operations';
import { popupAsyncMessage } from '../../messages/business-logic/popup-message';
import { updateTouchPointConfiguration } from '../../touchpoint/business-logic/touchpoint-configuration';
import { forceSignInPost } from './service/force-sign-in-service';
import { enterTrainingMode } from './service/set-training-mode';
import { shiftStart } from './service/shift-start-service';
import { signOff } from './sign-off';
import XLRLogger from 'src/common/helpers/logger';

export const forceSignIn = async (
  forceSignInCreds: ForceSignInDto,
  useTraningModeAPIs: boolean,
): Promise<void> => {
  await forceSignInPost(forceSignInCreds).then(
    async (data): Promise<void> => {
      updateSession(forceSignInCreds.user, data);
      tryUpdateTouchPoint(data);

      if (forceSignInCreds.trainingMode && store.getState().pinPad.isPinpadConfigured) {
        await enablePayments().catch(async () => {
          const message: IMessageModal = {
            message: 'TrainingPinPadConfiguration',
            type: EmeraldDialogTypes.Error,
            subMessage: 'TrainingPinPadConfigurationDescription',
          };
          await popupAsyncMessage(message);
          await disablePayments();
        });
      }
      if (store.getState().posMode.trainingMode && useTraningModeAPIs) {
        enterTrainingMode();
      }
      await updateTouchPointConfiguration();

      if (store.getState().pinPad.isPinpadConfigured) {
        await enablePayments();
      }
    },
  );
};

const updateSession = (user: ILoginUser, loginInfo: ILoginUser): void => {
  if (!loginInfo.userName) {
    loginInfo.userName = user.userName;
  }
  loginInfo.isAuthenticated = true;
  store.dispatch(LoginActions.setLogin(loginInfo));

  notifyCashierShiftStart();
};

const notifyCashierShiftStart = async (): Promise<void> => {
  await shiftStart('OnSignIn').catch(err => {
    if (err.code === 'AccountNotFound') {
      signOff();
    } else {
      XLRLogger.error({
        message: `ShiftStartCommand: Failed notifying cashier shift start, but continue execution. Ex :${err.Message}`,
        source: 'force-sign-in.ts',
      });
      throw err;
    }
  });
};

const tryUpdateTouchPoint = (loginInfo: ILoginUser): void => {
  if (loginInfo.touchPointId) {
    LocalStorage.setTillId(loginInfo.touchPointId);
  }
};
